<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->

    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  caijiSuper,
  makeSuper,
  getZip,
  isAutoChangeErrorBbs,
  isAuto,
  changeErrorBbs,
  changeStatus
} from '@/api/LhcManage/LhcUrl'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data() {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('域名'),
        key: 'url',

        minWidth: 80,
        align: 'center'
      }, {
        title: '每天10:30自动更新',
        align: 'center',
        width: 130,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isAuto,
            },
            on: {
              'on-change': function (status) {
                isAuto(params.row.id).then(response => {
                  this.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, vm.$t('open_choose')),
            h('span', {
              slot: 'close'
            }, vm.$t('close_choose'))
          ])
        }
      }, {
        title: '自动替换错误帖子',
        align: 'center',
        width: 130,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isAutoChangeErrorBbs,
            },
            on: {
              'on-change': function (status) {
                isAutoChangeErrorBbs(params.row.id).then(response => {
                  this.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, vm.$t('open_choose')),
            h('span', {
              slot: 'close'
            }, vm.$t('close_choose'))
          ])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 1000,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'error',
              loading: this.isCaiji,
            },
            style: {
              margin: '0 5px'
            },

            on: {
              'click': () => {
                this.$Message.success('采集最新数据,并更新资料,请稍候')
                this.isCaiji = true;
                caijiSuper().then(response => {
                  this.isCaiji = false;
                  this.$Message.success(response.data.msg)
                })
              }
            }
          }, this.$t('采集开奖')), h('Button', {
            props: {
              type: 'info'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                vm.$router.push({
                  name: '首页资料', //是中文的
                  params: {
                    isXg: '1',
                    url: params.row.url,
                    issue: params.row.issueXg
                  }
                })
              }
            }
          }, this.$t('香港首页资料')), h('Button', {
            props: {
              type: 'info'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                vm.$router.push({
                  name: '帖子资料', //是中文的
                  params: {
                    isXg: '1',
                    url: params.row.url,
                  }
                })
              }
            }
          }, this.$t('香港帖子资料')), h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                vm.$router.push({
                  name: '首页资料', //是中文的
                  params: {
                    isXg: '0',
                    url: params.row.url,
                    issue: params.row.issueAm
                  }
                })
              }
            }
          }, this.$t('澳门首页资料')), h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                vm.$router.push({
                  name: '帖子资料', //是中文的
                  params: {
                    isXg: '0',
                    url: params.row.url,
                  }
                })
              }
            }
          }, this.$t('澳门帖子资料')), h('Button', {
            props: {
              type: 'error'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                changeErrorBbs().then(response => {
                  this.$Message.success(response.data.msg)
                })
              }
            }
          }, this.$t('一键更换错误帖子资料')), h('Button', {
            props: {
              type: 'error'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                makeSuper().then(response => {
                  this.$Message.success(response.data.msg)
                })
              }
            }
          }, this.$t('一键生成')), h('Button', {
            props: {
              type: 'info'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                getZip().then(response => {
                  this.$Message.success(response.data.msg)
                  window.open('http://'+response.data.data, '_blank')
                })
              }
            }
          }, this.$t('下载本期文件(用于手动上传FTP)')), h('Button', {
            props: {
              type: 'info'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                window.open(params.row.testUrl, '_blank')
              }
            }
          }, this.$t('查看站点'))])
        }
      }],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      isCaiji: false,
      //弹窗--------------
      //----------------
    }
  },
  created() {
    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcUrl/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcUrl/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcUrl/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted() {

  },
  methods: {

    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
  }
}
</script>
